import PropTypes from 'prop-types';
import Link from 'next/link';
import styles from './footerFlatNav.module.scss';

export default function FooterFlatNav({
  navData = [],
  config = {
    startMenusFrom: 'Right',
  },
}) {
  const { startMenusFrom } = config;
  return (
    <div
      className={`${styles.flatNavigation} ${
        styles[`menusFrom${startMenusFrom}`]
      }`}
    >
      {navData?.length > 0 && (
        <ul className={styles.flatList}>
          {navData?.map((nav, index) => {
            const navKey = `nav-${index}`;
            return (
              <li className={styles.flatListItem} key={navKey}>
                <Link href={nav?.link} data-testid={nav?.label}>
                  {nav?.label}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

FooterFlatNav.propTypes = {
  navData: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  config: PropTypes.shape({
    startMenusFrom: PropTypes.oneOf(['Left', 'Right']),
  }),
};
